<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <material-card
          color="secondary"
          title="Faturas Individualizadas"
          text=""
        >
          <v-flex xs12 md12 class="text-lg-right">
            <div
              class="text-xs-rigth text-md-rigth text-lg-rigth"
              v-if="items.length > 0"
            >
              <v-btn
                color="primary"
                outline
                slot="start"
                @click="_export(items)"
              >
                <v-icon left>mdi-file-excel</v-icon>Exportar
              </v-btn>
            </div>
          </v-flex>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            :loading="true"
            no-data-text="Não há faturas para essa competencia"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading text-xs-right font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.user.name | formatName }}</td>
              <td class="text-xs-right">
                {{
                  (item.tarifa * (item.amount_kW / item.amount)).toFixed(2) || 0
                }}
              </td>
              <td class="text-xs-right">
                {{ item.amount_kW || 0 | formatCurrency }}
              </td>
              <td class="text-xs-right" v-if="total">
                {{ (item.amount_kW / total) * 100 || 0 | formatPercent }}%
              </td>
              <td class="text-xs-right" v-else>-</td>
              <td class="text-xs-right">{{ item.balance || 0 }}</td>
              <!-- Para faturas antes de 07/2019 - Antes da Mudança para Pagarme -->
              <td
                class="text-xs-right"
                v-if="item.transaction && item.competence < '2019-07'"
              >
                R$
                {{
                  item.transaction
                    ? item.transaction.cost
                    : 0 || 0 | formatCurrency
                }}
              </td>
              <td
                class="text-xs-right"
                v-if="item.transaction && item.competence < '2019-07'"
              >
                R$
                {{
                  item.transaction
                    ? item.total - item.transaction.cost
                    : 0 || 0 | formatCurrency
                }}
              </td>
              <td class="text-xs-center" v-if="!item.transaction">-</td>

              <!-- Para faturas de 07/2019 em diante - Após Mudança para Pagarme -->
              <td
                class="text-xs-right"
                v-if="item.transactionPagarme && item.competence >= '2019-07'"
              >
                R$
                {{
                  (sumFee(item.transactionPagarme.payables) +
                    (item.transactionPagarme.payment_method === "credit_card"
                      ? item.transactionPagarme.cost / 100
                      : 0))
                    | formatCurrency
                }}
              </td>
              <td
                class="text-xs-right"
                v-if="item.transactionPagarme && item.competence >= '2019-07'"
              >
                R$
                {{
                  item.transactionPagarme
                    ? item.total -
                      (sumFee(item.transactionPagarme.payables) +
                        (item.transactionPagarme.payment_method ===
                        "credit_card"
                          ? item.transactionPagarme.cost / 100
                          : 0))
                    : 0 || 0 | formatCurrency
                }}
              </td>
              <td class="text-xs-center" v-if="!item.transactionPagarme">-</td>

              <td class="text-xs-right">
                R$ {{ item.discount || 0 | formatCurrency }}
              </td>
              <td class="text-xs-center">
                {{ item.next_read | formatNextRead }}
              </td>
              <td class="text-xs-right" v-if="item.transaction">
                <v-icon>{{
                  item.transaction
                    ? item.transaction.payment_method
                    : "" || "" | formatPaymentType
                }}</v-icon>
              </td>
              <td class="text-xs-right" v-else>-</td>
              <td class="text-xs-right">
                <v-icon
                  v-if="
                    item.status !== 'paga' &&
                    item.status !== 'succeeded' &&
                    item.status !== 'paid'
                  "
                  >{{ item.status | formatStatus }}</v-icon
                >
                <v-icon color="primary" v-else>{{
                  item.status | formatStatus
                }}</v-icon>
              </td>
            </template>
          </v-data-table>
          <template v-slot:loading>
            <v-progress-linear
              v-if="loading"
              height="2"
              color="cyan"
              indeterminate
            ></v-progress-linear>
          </template>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { EventBus } from "../../utils/event-bus";
import XLSX from "xlsx";
import moment from "moment";

export default {
  //props: ['items', 'total'],
  data: () => ({
    loading: false,
    loading_search: false,
    dialog: false,
    items: [],
    total: 0,
    cols: [],
    data: [
      [
        "Indice",
        "Competencia",
        "Nome",
        // 'UC',
        "Créditos kW",
        "% de Aluguel",
        "Créditos",
        "Mensalidade",
        "Taxa",
        "Receita Liquida",
        "Economia",
        "Saldo",
        "Total Consumido",
        "Método de Pagamento",
        "Status",
      ],
    ],
    headers: [
      {
        sortable: true,
        text: "Nome",
        value: "name",
      },
      {
        sortable: true,
        text: "Consumo kWh",
        value: "tarifa",
      },
      {
        sortable: true,
        text: "Créditos kWh",
        value: "item.amount_kW",
      },
      {
        sortable: true,
        text: "%",
        value: "percent",
      },
      {
        sortable: false,
        text: "Saldo kWh",
        value: "amount",
      },
      {
        sortable: false,
        text: "Taxa",
        value: "transaction",
      },
      {
        sortable: false,
        text: "Receita",
        value: "fat",
      },
      {
        sortable: false,
        text: "Economia",
        value: "discount",
      },
      {
        sortable: true,
        text: "Leitura",
        value: "next_read",
      },
      {
        sortable: false,
        text: "Mét. Pag.",
        value: "transaction.payment_method",
      },
      {
        sortable: false,
        text: "Status",
        value: "status",
      },
    ],
  }),
  mounted() {
    EventBus.$on("LoadInvoices", (invoices) => {
      // console.log('LoadInvoices: ', invoices)
      this.items = invoices;
    });
    EventBus.$on("InvoiceTotal", (total) => {
      // this.total = total.power_plant_amount
      this.total = total.total_amount_kw || 0;
      // this.total = total.power_plant_amount + (total.last_balance - total.current_balance - total.total_consumo_kW)
      // console.log('total: ', this.total)
    });
  },
  methods: {
    _export(items) {
      /* convert state to workbook */
      items.forEach((item, index) => {
        item.id = index;
        /*
                var ucs = [];
                item.consumer_units.forEach(uc => {
                    ucs.push(uc.consumer_unit)
                })
                */
        let taxa = 0;
        let receita = 0;
        if (item.transaction && item.competence < "2019-07") {
          taxa = item.transaction.cost;
          receita = item.total - item.transaction.cost;
        } else {
          if (item.transactionPagarme && item.transactionPagarme.payables) {
            taxa =
              this.sumFee(item.transactionPagarme.payables) +
              (item.transactionPagarme.payment_method === "credit_card"
                ? item.transactionPagarme.cost / 100
                : 0);
            receita =
              item.total -
              (this.sumFee(item.transactionPagarme.payables) +
                (item.transactionPagarme.payment_method === "credit_card"
                  ? item.transactionPagarme.cost / 100
                  : 0));
          } else {
            taxa = 0;
            receita = 0;
          }
        }
        this.data.push([
          index + 1,
          item.competence,
          item.user.name || 0,
          // ucs,
          item.amount_kW * 1,
          item.amount_kW / this.total,
          item.amount * 1,
          item.total * 1,
          taxa * 1 || 0,
          receita * 1 || 0,
          item.discount * 1,
          item.balance || 0,
          item.tarifa * 1 || 0,
          item.transaction ? item.transaction.payment_method : "" || "",
          item.status || "",
        ]);
        // console.log('data: ', this.data)
      });
      const ws = XLSX.utils.aoa_to_sheet(this.data);
      const wb = XLSX.utils.book_new();

      const file = "faturamento_" + this.formatFileName(new Date());
      // XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      XLSX.utils.book_append_sheet(wb, ws, file);
      /* generate file and send to client */
      XLSX.writeFile(wb, file + ".xlsx");
    },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    sumFee(value) {
      if (!value || value.length === 0) return 0;
      var sum = value.reduce(function (sum, elem) {
        return sum + elem.fee;
      }, 0);
      return sum / 100;
    },
  },
  filters: {
    formatCurrency(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatPercent(value) {
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val;
    },
    formatStatus: function (value) {
      if (!value) return "";

      if (value === "paga" || value === "succeeded" || value === "paid") {
        return "done_outline";
      } else if (
        value === "aberta" ||
        value === "pending" ||
        value === "waiting_payment" ||
        value === "opened"
      ) {
        return "schedule";
      } else if (value === "overdue") {
        return "schedule";
      } else if (value === "free") {
        return "free_breakfast";
      } else {
        return "error";
      }
    },
    formatPaymentType: function (value) {
      if (!value) return "";

      if (value === "credit" || value === "credit_card") return "credit_card";
      else return "mdi-barcode";
    },
    formatName: function (value) {
      if (!value) return "";
      if (value.length > 25) {
        return value.substr(0, 25) + "...";
      } else {
        return value;
      }
    },
    sumFee(value) {
      if (!value || value.length === 0) return 0;
      var sum = value.reduce(function (sum, elem) {
        return sum + elem.fee;
      }, 0);
      return sum / 100;
    },
    formatNextRead(value) {
      if (!value) return "";
      let date = value.toDate();
      return moment(date).format("DD/YYYY");
    },
  },
};
</script>
